export default "__VITE_ASSET__BaOLm7aS__"